import Acomodacoes from './Acomodacoes'
import FuncaoCirurgiao from './FuncaoCirurgiao'
import Graus from './Graus'
import Masks from './Masks'
import Plans from './Plans'
import ProcedimentosConsultaAcomodacao from './ProcedimentosConsultaAcomodacao'
import ProducaoProcedimento from './ProducaoProcedimento'
import PropertiesFilterProcedimentos from './PropertiesFilterProcedimentos'
import QuantidadeProcedimentos from './QuantidadeProcedimentos'
import TipoAtendimento from './TipoAtendimento'
import TipoFontePagadora from './TipoFontePagadora'
import TiposPrazoRecebimento from './TiposPrazoRecebimento'
import TiposProcedimento from './TiposProcedimento'
import ViasAcesso from './ViasAcesso'

export default {
  Acomodacoes,
  FuncaoCirurgiao,
  Graus,
  Masks,
  Plans,
  ProcedimentosConsultaAcomodacao,
  ProducaoProcedimento,
  PropertiesFilterProcedimentos,
  QuantidadeProcedimentos,
  TipoAtendimento,
  TipoFontePagadora,
  TiposPrazoRecebimento,
  TiposProcedimento,
  ViasAcesso,
}
